import { useCallback, useMemo, useState } from 'react';
import Raven from 'raven-js';
import { hasMultipleBillingTerms } from 'pricing-pages-ui-hsoc/components/merch-card-grid/HsocMerchCardPrice';
import { useGetPublicProductTierOptionsV2Query } from 'pricing-pages-ui-public-app/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.hooks';
import { DEFAULT_CHIRP_TIMEOUT } from '../../constants/chirpDefaults';
import { isCountryCodeString } from '../../utils/currencyTypes';
import { getBrowserLocale, getCountryCode } from '../../utils/getPreferredLanguage';
import { mapProductsByTierToCards } from './hsocPublicCards';
export function useHsocPublicPricing(currencyCode) {
  const [selectedTerm, setSelectedTerm] = useState('ANNUAL');
  const browserLocale = useMemo(() => getBrowserLocale(), []);
  const rawCountryCode = useMemo(() => getCountryCode(), []);
  const preferredCountryCode = useMemo(() => isCountryCodeString(rawCountryCode) ? rawCountryCode : undefined, [rawCountryCode]);
  const handleError = useCallback(error => {
    Raven.captureException(error, {
      fingerprint: ['failed-to-fetch-public-product-tier-options-v2'],
      extra: {
        currencyCode,
        preferredCountryCode,
        browserLocale
      }
    });
  }, [currencyCode, preferredCountryCode, browserLocale]);
  const {
    data,
    loading,
    error
  } = useGetPublicProductTierOptionsV2Query({
    variables: {
      browserLocale,
      preferredCountryCode,
      currencyCode
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    },
    onError: handleError
  });

  /* TODO(#22236): badge is still a placeholder; the V2 tier data does not yet
   * expose a badge field to map from. */
  const cards = useMemo(() => mapProductsByTierToCards(data === null || data === void 0 ? void 0 : data.productsByTier, currencyCode, selectedTerm), [data === null || data === void 0 ? void 0 : data.productsByTier, currencyCode, selectedTerm]);
  const showTermToggle = useMemo(() => hasMultipleBillingTerms(data === null || data === void 0 ? void 0 : data.productsByTier), [data === null || data === void 0 ? void 0 : data.productsByTier]);
  return {
    loading,
    error,
    cards,
    showTermToggle,
    selectedTerm,
    onTermChange: setSelectedTerm
  };
}